// extracted by mini-css-extract-plugin
export default {"itemMore":"styles_item-more__VG7Jf","searchRow":"styles_search-row__F7Xdf","listGroup":"styles_list-group__3EO7b","avatar":"styles_avatar__rA2t8"};